import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { formatDate } from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import { Button, TextInput } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';
import SubmitButton from 'af-components/SubmitButton';

import * as TimeSheetActions from 'af-actions/timeSheet';

import styles from './styles.module.scss';

interface OwnProps {
	showModal: boolean;
	code: string;
	employeeFullName: string;
	dueDate: string;
	accountId: number;
	workOrderId: number;
	close: () => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const RejectModal: React.FC<Props> = (props) => {
	const { showModal, code, employeeFullName, dueDate, accountId, workOrderId, close, reject } = props;

	const [reason, setReason] = React.useState('');
	const [submitting, setSubmitting] = React.useState(false);

	const date = formatDate(dueDate, TimeFormat.SB_DATE_LONG, TimeFormat.DB_DATE_ONLY);
	const disabled = !reason.length;

	const handleClose = React.useCallback(() => {
		setReason('');
		close();
	}, [close]);

	const handleReasonChange = React.useCallback((value: string) => {
		setReason(value);
	}, []);

	const handleReject = React.useCallback(async () => {
		if (!reason.length) {
			return;
		}

		setSubmitting(true);
		try {
			await reject(workOrderId, accountId, { reason });
			handleClose();
		} finally {
			setSubmitting(false);
		}
	}, [reason, reject, workOrderId, accountId, handleClose]);

	return (
		<CustomModal
			closeModal={handleClose}
			showModal={showModal}
			size="md"
		>
			<CustomModal.Header
				closeModal={handleClose}
				title="Reject Time Sheet"
			/>
			<CustomModal.Body>
				<span>
					Reject time sheet for <b>{employeeFullName}</b> on <b>{date}</b> for Work Order <b>{code}</b>?
				</span>
				<div className={styles.reasonInput}>
					<TextInput
						isRequired={true}
						label="Reason"
						name="reason"
						onChange={handleReasonChange}
						placeholder="Rejection reason..."
						value={reason}
					/>
				</div>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={handleClose}
					style="secondary"
					submitting={submitting}
				/>
				<SubmitButton
					disabled={disabled}
					label="Reject"
					onClick={handleReject}
					reduxFormSubmitting={submitting}
					variant="danger"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

function mapDispatchToProps() {
	return {
		reject: TimeSheetActions.reject,
	};
}

const connector = connect(null, mapDispatchToProps());
export default connector(RejectModal);
